import React from "react";
import './Button.scss'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Button = ({ label, link, scrollToTop, onClick, icon, accent }) => {
    
    return (React.createElement("a", { className: `button ${accent ? 'button__accent' : ''} ${scrollToTop ? 'button-scrollToTop' : ''}`, href: link, label, onClick: onClick }, label, icon ? <FontAwesomeIcon icon={icon} style={{ marginLeft : '12px'}} /> : ''));
};

export { Button as default };